import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createCapitalRequest,
  fetchCapitalRequests,
} from '../redux/slices/capitalSlice';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/CompanyCapital.css';

const ITEMS_PER_PAGE = 5;

const CompanyCapital = () => {
  const dispatch = useDispatch();
  const { capitalRequests, loading, error } = useSelector((state) => state.capital);

  const [capitalRecord, setCapitalRecord] = useState({
    authorized: '',
    issued: '',
    issueDate: '',
  });

  const [currentPage, setCurrentPage] = useState(1);

  // Fetch on mount
  useEffect(() => {
    dispatch(fetchCapitalRequests());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCapitalRecord({ ...capitalRecord, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { authorized, issued } = capitalRecord;

    if (authorized && issued) {
      const requestedAmount = parseFloat(issued);
      const branchId = 12;

      try {
        await dispatch(createCapitalRequest({ branchId, requestedAmount })).unwrap();
        toast.success('Capital request created successfully!');
        dispatch(fetchCapitalRequests());
        setCapitalRecord({ authorized: '', issued: '', issueDate: '' });
      } catch (err) {
        toast.error('Failed to create capital request.');
        console.error('Submission error:', err);
      }
    }
  };

  const totalPages = Math.ceil(capitalRequests.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentData = capitalRequests.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <div className="CompanyCapital-container">
      <ToastContainer />
      <h2 className="CompanyCapital-title">Company Capital Management</h2>

      {/* Section 1: Add Capital Record */}
      <section className="CompanyCapital-form-section">
        <h3 className="CompanyCapital-section-title">Add Capital Record</h3>
        <form onSubmit={handleSubmit} className="CompanyCapital-form">
          <div className="CompanyCapital-form-group">
            <label>Authorized Capital</label>
            <input
              type="number"
              name="authorized"
              value={capitalRecord.authorized}
              onChange={handleChange}
              placeholder="₹ 0.00"
              required
            />
          </div>
          <div className="CompanyCapital-form-group">
            <label>Issued Capital</label>
            <input
              type="number"
              name="issued"
              value={capitalRecord.issued}
              onChange={handleChange}
              placeholder="₹ 0.00"
              required
            />
          </div>
          <div className="CompanyCapital-form-group">
            <label>Issue Date</label>
            <input
              type="date"
              name="issueDate"
              value={capitalRecord.issueDate}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="CompanyCapital-save-btn">
            Save Capital Record
          </button>
        </form>
      </section>

      {/* Section 2: Capital Records Table */}
      <section className="CompanyCapital-table-section">
        <h3 className="CompanyCapital-section-title">Capital Requests</h3>
        <div className="CompanyCapital-table-wrapper">
          <table className="CompanyCapital-table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Branch ID</th>
                <th>Approved Amount</th>
                {/* <th>Status</th> */}
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="5">Error: {error}</td>
                </tr>
              ) : currentData.length === 0 ? (
                <tr>
                  <td colSpan="5">No capital requests found.</td>
                </tr>
              ) : (
                currentData.map((rec, index) => (
                  <tr key={rec.id}>
                    <td>{startIndex + index + 1}</td>
                    <td>{rec.branchId||"N/A"}</td>
                    <td>{`₹${parseFloat(rec.requestedAmount).toFixed(2)}`||"N/A"}</td>
                    {/* <td>{rec.status}</td> */}
                    <td>{new Date(rec.createdAt).toLocaleDateString("en-GB")||"N/A"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="CompanyCapital-pagination">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </section>
    </div>
  );
};

export default CompanyCapital;
